export const initialState = {
  searchBy: "",
  searchQuery: "",
  page: 1,
  pageSize: 10,
  sortKey: "",
  sortOrder: "",
  isAppend: false,
  isFiltered: false,
  selectedWaiver: null,
  docIndex: 0
}

export const ACTIONS = {
  SET_SEARCH: "SET_SEARCH",
  SET_SEARCH_QUERY: "SET_SEARCH_QUERY",
  SET_PAGE: "SET_PAGE",
  SET_PAGE_SIZE: "SET_PAGE_SIZE",
  SET_SORT: "SET_SORT",
  SET_APPEND: "SET_APPEND",
  SELECT_WAIVER: "SELECT_WAIVER",
  CLOSE_MODAL: "CLOSE_MODAL"
}

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_SEARCH:
      return { ...state, searchBy: action.payload }
    case ACTIONS.SET_SEARCH_QUERY:
      return { ...state, searchQuery: action.payload, page: 1, isFiltered: !!action.payload }
    case ACTIONS.SET_PAGE:
      return { ...state, page: action.payload }
    case ACTIONS.SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload, page: 1 }
    case ACTIONS.SET_SORT:
      return { ...state, sortKey: action.payload.sortKey, sortOrder: action.payload.sortOrder, page: 1 }
    case ACTIONS.SET_APPEND:
      return { ...state, isAppend: action.payload }
    case ACTIONS.SELECT_WAIVER:
      return { ...state, selectedWaiver: action.payload, docIndex: 0 }
    case ACTIONS.CLOSE_MODAL:
      return { ...state, selectedWaiver: null }
    default:
      return state
  }
}
